<form [formGroup]="formPassword" (ngSubmit)="formPasswordSubmit()">
    <h1 mat-dialog-title class="text-center mb-3">
        <mat-icon class="mr-2">lock</mat-icon>
        {{'Change-Password.Title' | translate}}
    </h1>
    <div mat-dialog-content class="pb-3">

        <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>{{'Change-Password.NewPassword' | translate}}</mat-label>
            <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput placeholder="">
            <!-- <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button" matTooltip="Mostrar/Ocultar contraseña">
                <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button> -->
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
            <mat-label>{{'Change-Password.ConfirmPassword' | translate}}</mat-label>
            <input [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="passwordConfirm" matInput placeholder="">
            <mat-hint *ngIf="!passwordMatch" align="center" class="text-danger font-weight-bold">{{'Change-Password.PasswordMismatch' | translate}}</mat-hint>
            <button mat-icon-button matSuffix (click)="toggleConfirmPasswordVisibility()" type="button" matTooltip="Mostrar/Ocultar contraseña">
                <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>

    </div>
    <div mat-dialog-actions class="justify-content-end pt-3 border-top">
        <button mat-stroked-button type="button" mat-dialog-close color="accent" class="mr-2">
            <mat-icon>close</mat-icon>
            {{'Change-Password.Close' | translate}}
        </button>
    <button mat-raised-button type="submit" color="primary" class="mr-2" [disabled]="!formPassword.valid">
            <mat-icon>save</mat-icon>
            {{'Change-Password.Save' | translate}}
        </button>
    </div>
</form>